/**
 * Hook definitions
 */

export interface MapFloor {
  id: string
  name: string
  levelIndex: number
  shortName: string
}

export interface MapBuilding {
  id: string
  name: string
  floors: MapFloor[]
}

export interface MovePosition {
  mode?: string
  buildingID?: string
  floorID?: string
}

export interface PoiMap {
  [id: string]: string // mapping id : name
}

// OWN TYPES

export interface PlaceDetailsShortcuts {
  iconName: IconName
  label?: string
  onClick: () => void
}

export enum RoomType {
  MEETING_ROOM = 'meetingRoom',
  OFFICE = 'office',
  RESTAURANT = 'restaurant',
  OTHER = 'other',
}

export enum RoomFilterType {
  ALL = 'all',
  MEETING_ROOM = 'meetingRoom',
  OFFICE = 'office',
  RESTAURANT = 'restaurant',
}
